{
  "Approve": "Aprobar",
  "DeleteReminder": "Borrar recordatorio",
  "DismissAlert": "Descartar",
  "DismissReminder": "Descartar recordatorio",
  "Earlier": "ANTERIOR",
  "EditReminder": "Editar recordatorio",
  "High": "Alto",
  "MarkAllAsRead": "Marcar todo como leído",
  "Reject": "Rechazar",
  "RemindMe15Min": "Recordatorio en 15 minutos",
  "RemindMe5Min": "Recordatorio en 5 minutos",
  "RemindMe60Min": "Recordatorio en una hora",
  "RemindMeTomorrow": "Recordatorio mañana",
  "Snooze": "Recordarme",
  "markAsRead": "Marcar como leído",
  "markAsUnread": "Marcar como no leído",
  "noNotifications": "Recibirá información importante sobre nuestros productos, su colaboración con otros usuarios y otras actualizaciones relevantes.",
  "noNotificationsTitle": "Las notificaciones aparecerán aquí"
}
